import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import {
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material'

import { format } from 'date-fns'
import { es } from 'date-fns/locale'

import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js'
import { Bar, Pie } from 'react-chartjs-2'

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale, 
  LinearScale, 
  Tooltip, 
  Legend
)

const Home = (props) => {
  const { director } = props

  const { firestore } = useFirebase()
  const {
    getGoalsBySchoolId,
    getPreceptorsBySchoolId,
    getStudentsBySchoolId,
    goals,
    preceptors,
    students,
  } = firestore

  const [data, setData] = useState({
    labels: ['Asignadas', 'Pendientes', 'Finalizadas'],
    datasets: [
      {
        label: 'Metas',
        data: [0, 0, 0],
        backgroundColor: ['#4d408433', '#655dc633', '#00c08b33'],
          borderColor: ['#4d4084', '#655dc6', '#00c08b'],
        borderWidth: 2,
      },
    ],
  })

  const [dataPerMonth, setDataPerMonth] = useState({
    labels: ['Agosto', 'Septiembre', 'Octubre'],
    datasets: [
      {
        label: 'Efectividad',
        data: [0, 0, 0],
        backgroundColor: ['#4d408433', '#655dc633', '#00c08b33'],
          borderColor: ['#4d4084', '#655dc6', '#00c08b'],
        borderWidth: 2,
      },
    ],
  })

  useEffect(() => {
    if (director === undefined) return
    const schoolId = director.schoolId
    getGoalsBySchoolId(schoolId)
    getStudentsBySchoolId(schoolId)
    getPreceptorsBySchoolId(schoolId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [director])

  useEffect(() => {
    if (goals === undefined) return
    const assigned = Object.values(goals).filter(goal => goal.status === 'Asignada')
    const finished = Object.values(goals).filter(goal => goal.status === 'Finalizada')
    const other = Object.values(goals).filter(goal => goal.status !== 'Finalizada' && goal.status !== 'Asignada')
    const data = {
      labels: ['Asignadas', 'Pendientes', 'Finalizadas'],
      datasets: [
        {
          label: 'Metas',
          data: [assigned.length, other.length, finished.length],
          backgroundColor: ['#4d408433', '#655dc633', '#00c08b33'],
          borderColor: ['#4d4084', '#655dc6', '#00c08b'],
          borderWidth: 2,
        },
      ],
    }
    setData(data)
    createGoalsMap()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goals])

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const createGoalsMap = () => {
    const goalsMap = {}
    const updates = []
    Object.values(goals).forEach(goal => {
      const date = new Date(goal.createdAt.seconds * 1000)
      const id = capitalizeFirstLetter(format(date, 'MMMM', { locale: es }))

      if (goalsMap[id] === undefined) {
        goalsMap[id] = {
          [goal.preceptorId]: [goal]
        }
      } else {
        if (goalsMap[id][goal.preceptorId] === undefined) {
          goalsMap[id][goal.preceptorId] = [goal]
        } else {
          goalsMap[id][goal.preceptorId].push(goal)
        }
      }
    })

    console.log(goalsMap)

    setDataPerMonth({
      labels: Object.keys(goalsMap),
      datasets: [
        {
          label: '% Efectividad',
          data: Object.values(goalsMap).map(obj => (Object.keys(obj).length * 100 / preceptors.length).toFixed(2)),
          backgroundColor: ['#4d408433'],
          borderColor: ['#4d4084'],
          borderWidth: 2,
        },
      ],
    })
  }

  const DashboardItem = (props) => {
    const { label, value } = props
    return (
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Typography color='primary' variant='body2'>
            <b>{label}</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography color='primary' variant='h6'>
            <b style={{ fontWeight: 900 }}>{value}</b>
          </Typography>
        </Grid>
      </Grid>
    )
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        // text: 'Chart.js Bar Chart',
      },
    },
    scales: {
      yAxis: {
        min: 0,
        max: 100
      }
    }
  }

  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Typography color='primary' variant='h4'>
          <b style={{ fontWeight: 900 }}>Dashboard</b>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <DashboardItem label='Director actual' value={director !== undefined ? director.name : 'Sin asignar'} />
              </Grid>
              <Grid item xs={12} md={3}>
                <DashboardItem label='Total de alumnos' value={students === undefined ? 0 : Object.keys(students).length} />
              </Grid>
              <Grid item xs={12} md={3}>
                <DashboardItem label='Total de preceptores' value={preceptors === undefined ? 0 : Object.keys(preceptors).length} />
              </Grid>
              <Grid item xs={12} md={3}>
                <DashboardItem label='Total de metas' value={goals === undefined ? 0 : Object.keys(goals).length} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={3}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>METAS</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Pie data={data} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={5}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>EFECTIVIDAD</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Bar data={dataPerMonth} options={options} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default Home